import type { MessageDescriptor } from "react-intl";

import messages from "../locales/messages";

interface PasswordCheckResult {
  translation: MessageDescriptor;
  result: boolean;
}

export interface PasswordValidationResult {
  valid: boolean;
  checks: Array<PasswordCheckResult>;
}

// TODO: Unify this with the ValidatedPasswordInput component
// https://shapr3d.atlassian.net/browse/COL-3622
const validatePassword = (password: string): PasswordValidationResult => {
  const checks = [
    {
      translation: messages.PasswordValidation.HasLowercase,
      check: (value: string) => {
        return /^.*[a-z].*$/.test(value);
      },
    },
    {
      translation: messages.PasswordValidation.HasUppercase,
      check: (value: string) => {
        return /^.*[A-Z].*$/.test(value);
      },
    },
    {
      translation: messages.PasswordValidation.HasNumber,
      check: (value: string) => {
        return /^.*[0-9].*$/.test(value);
      },
    },
    {
      translation: messages.PasswordValidation.MinimumLength,
      check: (value: string) => {
        return value.length >= 8;
      },
    },
  ];

  let validation = true;
  const checkResults = new Array<PasswordCheckResult>();
  checks.forEach((passwordCheck) => {
    const result = passwordCheck.check(password);
    if (result === false) {
      validation = false;
    }
    checkResults.push({
      translation: passwordCheck.translation,
      result: result,
    });
  });

  return {
    valid: validation,
    checks: checkResults,
  };
};

export default validatePassword;
